module.exports = __webpack_public_path__ + "img/Best Practices_Paterno Baloloy Jr.1412e4ea.jpg";